import {
  AppstoreOutlined,
  BugOutlined,
  MessageOutlined,
  SearchOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import { UserRole } from "../../store/authStore";

interface SidebarProps {
  role: UserRole;
}

const baseItems = [
  { key: "/dashboard", icon: <AppstoreOutlined />, label: "Overview" },
  {
    key: "/tracking-details",
    icon: <SearchOutlined />,
    label: "Tracking Details",
  },
  { key: "/sessions", icon: <MessageOutlined />, label: "Sessions" },
  { key: "/errors", icon: <BugOutlined />, label: "Errors" },
];

const adminItem = {
  key: "/admin/users",
  icon: <TeamOutlined />,
  label: "User Management",
};

const Sidebar = ({ role }: SidebarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const items = role === "admin" ? [...baseItems, adminItem] : baseItems;

  return (
    <Layout.Sider
      breakpoint="lg"
      collapsedWidth="0"
      width={240}
      className="app-sidebar"
    >
      <div className="app-sidebar__brand">ePost Monitor</div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={items}
        onClick={({ key }) => navigate(key)}
      />
    </Layout.Sider>
  );
};

export default Sidebar;
